import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      id: this.$options.name,
      editTitle: "Edit space",
      createTitle: "Create space",
      optionsData: {},
      isSwatch: true,
      errors: [],
      clear: false,
      displayCreatedMessage: false,
    };
  },
  created() {
    this.editTitle = i18n.t("spaces.edit_space");
    this.createTitle = i18n.tc("spaces.create_space", 1);

    EventBus.$on(`${this.$options.name}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;

        //use hex by default
        this.isSwatch = false;
      } else {
        this.optionsData = {};
      }
    });

    EventBus.$on(`${this.$options.name}-edit`, (data) => {
      if (data.id) {
        this.editSpace(data.id);
      }
    });

    EventBus.$on(`${this.$options.name}-create`, () => {
      this.createSpace();
    });

    EventBus.$on(`${this.$options.name}-switch-color`, () => {
      this.isSwatch = !this.isSwatch;
    });

    EventBus.$on(`${this.$options.name}-created`, () => {
      //close current overlay
      EventBus.$emit("closeOverlayPage", { id: this.id });

      this.displayCreatedMessage = false;
    });

    //hide message on close overlay
    EventBus.$on("closeOverlayPage", (data) => {
      if (this.id === data.id) {
        this.displayCreatedMessage = false;
      }
    });
  },

  methods: {
    isEditType() {
      return this.optionsData.spaceId;
    },

    wipeValues() {
      //invoke change so the watcher updates
      this.clear = !this.clear;
    },

    editSpace(id) {
      const formData = new FormData(this.$refs.updateForm);

      formData.append("foldertoupdate", id);
      formData.append("myspace", "0");

      formData.set("color", formData.get("color").replaceAll("#", ""));

      this.$axios
        .post(baseUrl + "/folderupdate", formData)
        .then((response) => {
          if (response.data.success) {
            this.wipeValues();

            //update list
            EventBus.$emit("spaces-holder-update-spaces", {});

            //close current overlay
            EventBus.$emit("closeOverlayPage", { id: this.id });
          } else {
            this.successend = false;
            if (response.data.msg == "duplicate") {
              this.errors.push(i18n.tc("spaces.create_space", 1));
            }
          }
        })
        .catch((response) => {});
    },

    createSpace() {
      const formData = new FormData(this.$refs.updateForm);

      formData.append("myspace", "0");
      formData.set("color", formData.get("color").replaceAll("#", ""));

      this.$axios
        .post(baseUrl + "/folderadd", formData)
        .then((r) => {
          if (r.data.success) {
            //show created screen
            this.displayCreatedMessage = true;

            //update list
            EventBus.$emit("spaces-holder-update-spaces", {});

            this.wipeValues();
          } else {
            switch (r.data.msg) {
              case "folder_exists":
                this.errors.push(i18n.tc("spaces.create_space", 1));
                break;
            }
          }
        })
        .catch((r) => {
          this.errors.push(i18n.t("common.something_went_wrong"));
        });
    },
  },
};
